<div fxLayout="column">
  <!-- Header -->
  <mat-card fxFlex fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" [class.banner-success]="data?.released" [class.banner-danger]="data?.isDeleted">
    <mat-card-content class="w-100">
      <mat-card-title fxLayout="row" fxLayoutAlign="start end" fxLayoutGap="10px">
        <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center"> 
          <div fxLayout="row" fxLayoutAlign="start center">
            <div [class.text-warning]="isExpired(data?.releaseDate)" matTooltip="{{ (isExpired(data?.releaseDate) ? 'Stopped processing ' : 'Processing until ' )}}{{ data?.releaseDate | date:'short' }}">{{ data?.name }}</div>
            <button *ngIf="!released" mat-icon-button class="small-icon" color="accent" (click)="edit('name')">
              <mat-icon>edit</mat-icon>            
            </button>            
            <button mat-icon-button color="accent" matTooltip="Extend release. This may cause other releases with a closer release date to take render priority!" (click)="addDays()">
              <mat-icon>more_time</mat-icon>
            </button>            
            <button mat-icon-button [matTooltip]="data?.renderReleaseStatus === renderReleaseStatuses.PreRelease ? 'Pre-Release - Changes to home files are being actively monitored and updated' : 'Pre-Release - Off'" [color]="data?.renderReleaseStatus === renderReleaseStatuses.PreRelease ? 'accent' : 'primary'" (click)="togglePreRelease()">
              <mat-icon>science</mat-icon>
            </button>
          </div>
          <small *ngIf="!released" matTooltip="Percentage of release items live" class="text-success">{{ getLivePercentage() }}% complete</small>
        </div>
      </mat-card-title>
      <div fxLayout="row" fxLayoutAlign="start center">
        <p *ngIf="data?.description">
          <span>{{ data.description }}</span>
        </p>
        <button *ngIf="!released" mat-icon-button class="small-icon" color="accent" (click)="edit('description')">
          <mat-icon>edit</mat-icon>
        </button>
        <mat-icon [class.link]="data?.situRaytracedPlus" 
          [class.disable-link]="!data?.situRaytracedPlus" 
          [matTooltip]="data?.situRaytracedPlus ? productNames[productNames.RayTracedPlus] + ' renders enabled' : productNames[productNames.RayTracedPlus] + ' renders not enabled'" 
          [style.color]="getProductColour(productNames.RayTracedPlus)"
          (click)="toggleRaytraced()">panorama</mat-icon>
        <mat-icon [class.link]="data?.situPlan" 
          [class.disable-link]="!data?.situPlan" 
          [matTooltip]="data?.situPlan ? 'situPLAN renders enabled' : 'situPLAN renders not enabled'" 
          [style.color]="getProductColour(productNames.Plan)"
          (click)="toggleSituPlan()">foundation</mat-icon>
        <mat-icon [class.link]="data?.situRender" 
          [class.disable-link]="!data?.situRender" 
          [matTooltip]="data?.situRender ? 'situRENDER renders enabled' : 'situRENDER renders not enabled'" 
          [style.color]="getProductColour(productNames.Render)"
          (click)="toggleSituRender()">photo_camera</mat-icon>
      </div>
      <div class="timeline-container m-t-20">
        <div *ngFor="let status of statusPercentages" class="segment"
             [matTooltip]="status.count + ' ' + releaseStatuses[status.status]" 
             [ngStyle]="{'background-color': getStatusColor(status.status), 'width': status.percentage + '%'}"
             (click)="filterReleaseStatus(status.status)">
        </div>
      </div>
      <div class="w-100 m-t-10" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-md="column">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-around center" fxLayout.lt-sm="column">
          <div class="stat-item">
            <mat-icon color="primary">collections</mat-icon>
            <div class="stat-value">{{releaseStats.totalItems}}</div>
            <div class="stat-label" [class.dark]="isDarkMode">Release Items</div>
          </div>
          <div class="stat-item">
            <mat-icon color="primary">home</mat-icon>
            <div class="stat-value">{{releaseStats.uniqueHomeConfigs}}</div>
            <div class="stat-label" [class.dark]="isDarkMode">Home Configs</div>
          </div>
          <div class="stat-item">
            <mat-icon color="primary">home</mat-icon>
            <div class="stat-value">{{releaseStats.uniqueHomes}}</div>
            <div class="stat-label" [class.dark]="isDarkMode">Homes</div>
          </div>
          <div class="stat-item">
            <mat-icon color="primary">architecture</mat-icon>
            <div class="stat-value">{{releaseStats.uniqueMasterFiles}}</div>
            <div class="stat-label" [class.dark]="isDarkMode">Master Files</div>
          </div>
          <div class="stat-item">
            <mat-icon color="primary">style</mat-icon>
            <div class="stat-value">{{releaseStats.uniqueStyleTemplates}}</div>
            <div class="stat-label" [class.dark]="isDarkMode">Style Templates</div>
          </div>
          <div class="stat-item">
            <mat-icon color="primary">tune</mat-icon>
            <div class="stat-value">{{releaseStats.uniqueOptions}}</div>
            <div class="stat-label" [class.dark]="isDarkMode">Options</div>
          </div>
        </div>
      </div>
      <div class="stat-item">
        <mat-icon color="primary">schedule</mat-icon>
        <div class="stat-value">{{ formatRenderTime(releaseStats.totalRenderTimeRemaining) }}</div>
        <div class="stat-label" [class.dark]="isDarkMode">Approximate Render Time Remaining</div>
      </div>
    </mat-card-content>
  </mat-card>
  <!-- Header -->
  <!-- Release Issues -->
  <mat-card fxFlex> 
    <mat-card-content>
      <div class="m-b-10" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <div fxLayout="column" fxLayoutAlign="center start" fxLayoutAlign.lt-sm="center center">
            <span [ngClass.lt-sm]="{'card-title': true}">Issues</span>
          </div>
        </div>
        <div>
          <button mat-flat-button color="primary" class="m-r-10" (click)="addEditReleaseIssue()">
            Add Issue<mat-icon>bug_report</mat-icon>
          </button>
          <a *ngIf="id" mat-flat-button color="accent" [href]="'/admin/release-issues?release=' + id" target="_blank">
            View Dashboard<mat-icon>dashboard</mat-icon>
          </a>
          <button mat-icon-button>
            <mat-icon *ngIf="!showReleaseIssues" matTooltip="Show Issues" (click)="showReleaseIssues = true">expand_more</mat-icon>
            <mat-icon *ngIf="showReleaseIssues" matTooltip="Hide Issues" (click)="showReleaseIssues = false">expand_less</mat-icon>
          </button>
        </div>
      </div>
      <release-issue-list *ngIf="showReleaseIssues"
        [companyId]="selectedCompany?.id"
        [hideEdit]="false"
        [isSituUser]="isSituUser"
        [hideReport]="false"
        [isSelectable]="true"
        [selectedReleaseIssue]="issueFilter"
        (onSelectClick)="onCardSelectClick($event)">
      </release-issue-list>
    </mat-card-content>
  </mat-card>
  <!-- Release Issues -->

  <!-- Release Items -->
  <mat-card fxFlex>
    <mat-card-content fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <button *ngIf="isSituUser" mat-flat-button color="primary" (click)="uploadCSV()" matTooltip="Upload CSV to import release items">
          Import Release Items
          <mat-icon>file_upload</mat-icon>
        </button>
        <button mat-flat-button color="accent" (click)="downloadJSON()">
          Export JSON
          <mat-icon>data_object</mat-icon>
        </button>
        <button mat-flat-button color="accent" (click)="downloadCSV()">
          Export CSV
          <mat-icon>view_list</mat-icon>
        </button>
      </div>
      <mat-card class="mat-card-inline-sm">
        <mat-card-content>
          <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
            <mat-form-field class="accent">
              <mat-label>Search release items</mat-label>
              <input matInput type="text"
                [(ngModel)]="searchTerm"
                (keyup.enter)="filterData()"
                (keyup.esc)="clearSearch(); filterData()"
                name="searchTerm"
                placeholder="Search release items">
              <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch(); filterData()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <div fxLayout="row" fxLayoutGap="10px">
              <button type="submit"
                mat-mini-fab color="primary"
                (click)="filterData()"
                matTooltip="Search"
                [class.button-spinner]="loading"
                [disabled]="loading">
                <mat-icon>search</mat-icon>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="m-b-20 w-100" fxFlex="100">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <small class="text-info"><i>filter:</i></small>
          <small *ngIf="!selectedHome && 
          !selectedMasterFile && 
          !selectedOption && 
          !selectedStyleTemplate && 
          selectedReleaseStatus === undefined && 
          selectedProductName === undefined &&
          !commentsFilter &&
          !ticketFilter &&
          !standardFilter &&
          !hiResFilter &&
          !viewedFilter &&
          !issueFilter" class="text-warning">
            no filters currently applied
          </small>
          <mat-chip-list>
            <mat-chip *ngIf="selectedHome" color="accent">
              <span>Home: {{ selectedHome }}</span>
              <button matChipRemove (click)="filterHome(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedMasterFile" color="accent">
              <span>MasterFile: {{ selectedMasterFile }}</span>
              <button matChipRemove (click)="filterMasterFile(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedOption" color="accent">
              <span>Options: {{ selectedOption }}</span>
              <button matChipRemove (click)="filterOption(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedStyleTemplate" color="accent">
              <span>Style Template: {{ selectedStyleTemplate }}</span>
              <button matChipRemove (click)="filterStyleTemplate(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedReleaseStatus" color="accent">
              <span>Status: {{ releaseStatuses[selectedReleaseStatus] }}</span>
              <button matChipRemove (click)="filterReleaseStatus(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="selectedProductName !== undefined" color="accent">
              <span>Product: {{ productNames[selectedProductName] }}</span>
              <button matChipRemove (click)="filterProductName(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip *ngIf="issueFilter" color="accent">
              <span>Release Issue</span>
              <button matChipRemove (click)="filterIssue(undefined)">
                <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="commentsFilter ? filterComments(false) : filterComments(true)">
              <span>Comments</span>
              <button matChipRemove>
                <mat-icon *ngIf="!commentsFilter" color="basic" matTooltip="Show Commented Release Items" (click)="filterComments(true)">comment</mat-icon>
                <mat-icon *ngIf="commentsFilter" color="primary" matTooltip="Clear filter" (click)="filterComments(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="ticketFilter ? filterTickets(false) : filterTickets(true)">
              <span>Tickets</span>
              <button matChipRemove>
                <mat-icon *ngIf="!ticketFilter" color="basic" matTooltip="Show Ticketed Release Items" (click)="filterTickets(true)">support</mat-icon>
                <mat-icon *ngIf="ticketFilter" color="primary" matTooltip="Clear filter" (click)="filterTickets(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="standardFilter ? filterStandard(false) : filterStandard(true)">
              <span>Standard</span>
              <button matChipRemove>
                <mat-icon *ngIf="!standardFilter" color="basic" matTooltip="Show Standard Release Items" (click)="filterStandard(true)">image</mat-icon>
                <mat-icon *ngIf="standardFilter" color="primary" matTooltip="Clear filter" (click)="filterStandard(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="hiResFilter ? filterHiRes(false) : filterHiRes(true)">
              <span>HiRes</span>
              <button matChipRemove>
                <mat-icon *ngIf="!hiResFilter" color="basic" matTooltip="Show HiRes Release Items" (click)="filterHiRes(true)">4k_plus</mat-icon>
                <mat-icon *ngIf="hiResFilter" color="primary" matTooltip="Clear filter" (click)="filterHiRes(false)">clear</mat-icon>
              </button>
            </mat-chip>
            <mat-chip color="accent" (click)="viewedFilter ? filterViewed(false) : filterViewed(true)">
              <span>Viewed</span>
              <button matChipRemove>
                <mat-icon *ngIf="!viewedFilter" color="basic" matTooltip="Show Viewed Release Items" (click)="filterViewed(true)">visibility</mat-icon>
                <mat-icon *ngIf="viewedFilter" color="primary" matTooltip="Clear filter" (click)="filterViewed(false)">clear</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <mat-card *ngIf="!isExpired(data?.releaseDate)" class="contrast mat-card-inline-sm">
        <mat-card-content fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="start center">
          <div fxFlex="20" class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
            fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
            <label><span class="text-info">{{ selectedReleaseItems ? selectedReleaseItems.length : 0 }}</span> items selected.</label>
          </div>
          <div fxFlex="50" fxLayout="row" fxLayoutAlign="center center">
            <mat-form-field *ngIf="releaseItemFieldToUpdate !== undefined && releaseItemFieldToUpdate !== releaseItemFieldToUpdateOptions.Delete && selectedReleaseItems?.length > 0">
              <input *ngIf="releaseItemFieldToUpdate === releaseItemFieldToUpdateOptions.Comments || releaseItemFieldToUpdate === releaseItemFieldToUpdateOptions.SupportTicket" matInput type="text"
                [(ngModel)]="updateReleaseItemValue"
                name="updateReleaseItemValue"
                [placeholder]="'Set ' + releaseItemFieldToUpdateOptions[releaseItemFieldToUpdate]"
                required>
              <mat-select *ngIf="releaseItemFieldToUpdate === releaseItemFieldToUpdateOptions.ReleaseStatus"
                [(ngModel)]="updateReleaseItemEnumValue"
                name="updateReleaseItemEnumValue"
                required>
                <mat-option *ngFor="let item of releaseStatuses | enumKeyValue:'asc'" [value]="item.value">
                  {{ item.key }}
                </mat-option>
              </mat-select>
              <mat-select *ngIf="releaseItemFieldToUpdate === releaseItemFieldToUpdateOptions.AssignToReleaseIssue"
                [(ngModel)]="updateReleaseItemValue"
                name="updateReleaseItemValue"
                required>
                <mat-option *ngFor="let item of releaseIssues" [value]="item.id">
                  {{ item.title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button *ngIf="releaseItemFieldToUpdate !== undefined && selectedReleaseItems?.length > 0" [disabled]="!updateReleaseItemValue && !updateReleaseItemEnumValue"
                mat-button mat-icon-button
                [matTooltip]="'Set ' + releaseItemFieldToUpdateOptions[releaseItemFieldToUpdate]"
                (click)="setValues()"
                color="accent">
                <mat-icon>done</mat-icon>
              </button>
          </div>
          <div fxFlex="30" fxLayout="row" fxLayoutAlign="end center">
            <button
              mat-icon-button color="accent"
              matTooltip="Select All"
              aria-label="Select All"
              (click)="selectAll()">
              <mat-icon>select_all</mat-icon>
            </button>
            <ng-container>
              <button *ngIf="!released" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Set status"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.ReleaseStatus; clearValues();">
                <mat-icon>military_tech</mat-icon>
              </button>
              <button *ngIf="!released && !isSituUser" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Set comment"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.Comments; clearValues();">
                <mat-icon>comment</mat-icon>
              </button>
              <button *ngIf="!released && !isSituUser" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Set support ticket"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.SupportTicket; clearValues();">
                <mat-icon>support</mat-icon>
              </button>
              <button *ngIf="!released && isSituUser" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Assign to release issue"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.AssignToReleaseIssue; clearValues();">
                <mat-icon>bug_report</mat-icon>
              </button>
              <button *ngIf="!released" mat-icon-button [disabled]="selectedReleaseItems?.length === 0"
                color="primary"
                matTooltip="Delete release items"
                (click)="releaseItemFieldToUpdate = releaseItemFieldToUpdateOptions.Delete; deleteConfirm()">
                <mat-icon>delete</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-template matMenuContent>
                  <button *ngFor="let release of releases" mat-menu-item (click)="addToRelease(release.id)">
                    <span>{{ release?.name }}</span>
                  </button>
                </ng-template>
              </mat-menu>
              <button *ngIf="selectedReleaseItems?.length > 0 && released" 
                [matMenuTriggerFor]="menu"
                color="accent" mat-icon-button matTooltip="Add configurations to release" aria-label="Add configurations to release">
                <mat-icon>queue</mat-icon>
              </button>
              <button *ngIf="selectedReleaseItems?.length > 0"
                mat-icon-button color="basic"
                matTooltip="Cancel Select"
                aria-label="Cancel Select"
                (click)="clearSelection()">
                <mat-icon>deselect</mat-icon>
              </button>
              <button *ngIf="selectedReleaseItems?.length > 0"
                mat-icon-button color="primary"
                matTooltip="Copy to Style Template(s)"
                aria-label="Copy to Style Template(s)"
                (click)="copyToStyleTemplate()">
                <mat-icon>queue</mat-icon>
              </button>
              <button *ngIf="selectedReleaseItems?.length > 0 && selectedProductName === productNames.Facade"
                mat-icon-button color="primary"
                matTooltip="Download Facades"
                aria-label="Download Facades"
                (click)="downloadSelectedFacades()">
                <mat-icon>file_download</mat-icon>
              </button>
              <button *ngIf="selectedReleaseItems?.length > 0 && selectedProductName === productNames.Facade"
                mat-icon-button color="accent"
                matTooltip="Download HiRes Facades"
                aria-label="Download HiRes Facades"
                (click)="downloadSelectedFacades(true)">
                <mat-icon>file_download</mat-icon>
              </button>
            </ng-container>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card *ngIf="isExpired(data?.releaseDate) && selectedReleaseItems?.length > 0 && selectedProductName === productNames.Facade" class="contrast mat-card-inline-sm">
        <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
          <div fxFlex="20" class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row"
            fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
            <label><span class="text-info">{{ selectedReleaseItems ? selectedReleaseItems.length : 0 }}</span> items selected.</label>
          </div>
          <div fxLayoutAlign="end center" fxLayout="row">
            <button
              mat-icon-button color="accent"
              matTooltip="Select All"
              aria-label="Select All"
              (click)="selectAll()">
              <mat-icon>select_all</mat-icon>
            </button>
            <button *ngIf="selectedReleaseItems?.length > 0"
              mat-icon-button color="basic"
              matTooltip="Cancel Select"
              aria-label="Cancel Select"
              (click)="clearSelection()">
              <mat-icon>deselect</mat-icon>
            </button>
            <button mat-icon-button color="primary"
              matTooltip="Download Facades"
              aria-label="Download Facades"
              (click)="downloadSelectedFacades()">
              <mat-icon>file_download</mat-icon>
            </button>
            <button mat-icon-button color="accent"
              matTooltip="Download HiRes Facades"
              aria-label="Download HiRes Facades"
              (click)="downloadSelectedFacades(true)">
              <mat-icon>file_download</mat-icon>
            </button>
          </div>
          
        </mat-card-content>
      </mat-card>
      <mat-card class="contrast mat-card-inline-sm">
        <div></div>
        <mat-card-content>
          <div fxLayoutAlign="start center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
              <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="2px">
                <strong fxLayout="row" class="highlight" fxLayoutAlign="start center" matTooltip="Sorting by {{ getSortCriteriaName(sortCriteria) }}">{{ getSortCriteriaName(sortCriteria) }}</strong>
                <button [color]="sortOrder == 'asc' ? 'accent' : 'basic'" matTooltip="Sort Ascending" (click)="sortOrder = 'asc'; filterData();" mat-icon-button><mat-icon>expand_less</mat-icon></button> 
                <button [color]="sortOrder == 'desc' ? 'accent' : 'basic'" matTooltip="Sort Descending" (click)="sortOrder = 'desc'; filterData();" mat-icon-button><mat-icon>expand_more</mat-icon></button>
              </div>
              <small [class.link]="sortCriteria != 'home'" [class.highlight]="sortCriteria === 'home'" matTooltip="Sort by Home" (click)="sortCriteria = 'home'; filterData();">Home</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'masterFile'" [class.highlight]="sortCriteria === 'masterFile'" matTooltip="Sort by MasterFile" (click)="sortCriteria = 'masterFile'; filterData();">MasterFile</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'option'" [class.highlight]="sortCriteria === 'option'" matTooltip="Sort by Options" (click)="sortCriteria = 'option'; filterData();">Options</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'styleTemplate'" [class.highlight]="sortCriteria === 'styleTemplate'" matTooltip="Sort by Style Template" (click)="sortCriteria = 'styleTemplate'; filterData();">Style Template</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'renderType'" [class.highlight]="sortCriteria === 'renderType'" matTooltip="Sort by Render Type" (click)="sortCriteria = 'renderType'; filterData();">Render Type</small>
              <span>></span>
              <small [class.link]="sortCriteria != 'releaseStatus'" [class.highlight]="sortCriteria === 'releaseStatus'" matTooltip="Sort by Release Status" (click)="sortCriteria = 'releaseStatus'; filterData();">Release Status</small>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <ng-container *ngFor="let item of filteredReleaseItems; let i = index;">
        <mat-card class="w-100" fxFlex="100" *ngIf="i < pageLength"
        class="contrast mat-card-inline-sm"
        [class.banner-info]="isSelected(item.id)"
        (click)="toggleSelection(item.id)">
        <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="5px">
          <div fxFlex="80" fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px" fxLayout.lt-sm="column" fxLayoutGap.lt-sm="5px">
              <strong fxLayout="row" class="link" fxLayoutAlign="start center" matTooltip="Home" [innerHtml]="item.home | highlight: searchTerm" (click)="filterHome(item.home, $event); $event.stopPropagation();"></strong>
              <small class="link" [style.color]="getStatusColor(item.releaseStatus)" matTooltip="Master File" [innerHtml]="item.masterFile | highlight: searchTerm" (click)="filterMasterFile(item.masterFile, $event); $event.stopPropagation();"></small>
              <span *ngIf="item?.options" [fxHide.lt-sm]="true">></span>
              <small class="link" [style.color]="getStatusColor(item.releaseStatus)" matTooltip="Options" *ngIf="item?.options" [innerHtml]="item.options | highlight: searchTerm" (click)="filterOption(item.options, $event); $event.stopPropagation();"></small>
              <span [fxHide.lt-sm]="true">></span>
              <small class="link" [style.color]="getStatusColor(item.releaseStatus)" matTooltip="Style Template" [innerHtml]="item.styleTemplate | highlight: searchTerm" (click)="filterStyleTemplate(item.styleTemplate, $event); $event.stopPropagation();"></small>
              <span *ngIf="item?.productName !== undefined" [fxHide.lt-sm]="true">></span>
              <small class="link" *ngIf="item?.productName !== undefined" [style.color]="getProductColour(item.productName)" (click)="filterProductName(item.productName, $event); $event.stopPropagation();">{{ productNames[item.productName] }}</small>
              <span *ngIf="top100 && item?.latestVersion" [fxHide.lt-sm]="true">></span>
              <small *ngIf="top100 && item?.latestVersion" [style.color]="getStatusColor(item.releaseStatus)">views: {{ getViews(item.latestVersion) }}</small>
            </div>
          </div>
          <div fxFlex="20" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="0px" fxLayoutGap.lt-sm="10px">
            <div fxLayoutAlign="end center" fxLayout="row" fxLayoutAlign.lt-sm="center center" class="date-text">
              <small *ngIf="!released" class="link" [style.color]="getStatusColor(item.releaseStatus)" (click)="filterReleaseStatus(item.releaseStatus); $event.stopPropagation();">{{ releaseStatuses[item.releaseStatus] }}</small>
              <div class="m-l-10" *ngIf="!top100 && !released">|</div>
              <button *ngIf="item?.lastViewedName" mat-icon-button matTooltip="Viewed by {{ item?.lastViewedName }} @ {{ item?.dateLastViewed | date:'short' }}" color="accent" (click)="$event.stopPropagation();">
                <mat-icon>visibility</mat-icon>
              </button>
              <button *ngIf="!item?.lastViewedName" mat-icon-button matTooltip="Not viewed" color="primary" (click)="$event.stopPropagation();">
                <mat-icon>visibility_off</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Panorama || item?.productName == productNames.RayTraced" 
                      mat-icon-button 
                      [disabled]="!item?.latestVersion"
                      color="primary"
                      (click)="openLinkInNewWindow($event, '/situ-view', { id: item.latestVersion }); setReleaseItemViewed(item.id);"
                      [matTooltip]="item?.latestVersion ? 'Latest version available' : ''">
                <mat-icon>image</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Facade" 
                      mat-icon-button 
                      [disabled]="!item?.latestVersion"
                      color="primary"
                      (click)="openLinkInNewWindow($event, '/situ-facade', { id: item.latestVersion }); setReleaseItemViewed(item.id);"
                      [matTooltip]="item?.latestVersion ? 'Latest version available' : ''">
                <mat-icon>panorama</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Panorama || item?.productName == productNames.RayTraced" 
                      mat-icon-button 
                      [disabled]="!item?.latestVersion"
                      color="primary"
                      (click)="openSituLinkInNewWindow($event, item.latestVersion, false, true); setReleaseItemViewed(item.id);"
                      [matTooltip]="item?.latestVersion ? 'Latest version available' : ''">
                <mat-icon>share</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Facade" 
                      mat-icon-button 
                      [disabled]="!item?.latestVersion"
                      color="primary"
                      (click)="openSituLinkInNewWindow($event, item.latestVersion, true, true); setReleaseItemViewed(item.id);"
                      [matTooltip]="item?.latestVersion ? 'Latest version available' : ''">
                <mat-icon>share</mat-icon>
              </button>
              <button *ngIf="item?.productName == productNames.Facade && !released" mat-icon-button 
                  [disabled]="!item?.latestVersion && item.status !== releaseStatuses.ReadyForReview"
                  [color]="item?.approvedByName ? 'accent' : 'primary'"
                  (click)="approveForLive(item); $event.stopPropagation();"
                  [matTooltip]="item?.approvedByName ? 'Approved by ' + (item?.approvedByName ? item?.approvedByName : 'N/A') : 'Approve For Live'">
                <mat-icon *ngIf="item?.approvedByName">how_to_reg</mat-icon>
                <mat-icon *ngIf="!item?.approvedByName">done</mat-icon>
              </button>
              
              <ng-container *ngIf="item?.productName == productNames.Panorama && !released">
                <div *ngIf="!top100 && !released">|</div>
                <button mat-icon-button
                        [disabled]="!item?.higherResVersion && item.status !== releaseStatuses.ReadyForLive"
                        color="accent"
                        (click)="openLinkInNewWindow($event, '/situ-view', { id: item.higherResVersion });" 
                        matTooltip="situVIEW Raytraced">
                  <mat-icon>4k</mat-icon>
                </button>
                <button mat-icon-button 
                        [disabled]="!item?.higherResVersion && !released"
                        color="accent"
                        (click)="openSituLinkInNewWindow($event, item.higherResVersion, false);"
                        matTooltip="situVIEW Raytraced">
                  <mat-icon>share</mat-icon>
                </button>
                <ng-container *ngIf="data?.situRaytracedPlus">
                  <button mat-icon-button
                          [disabled]="!item?.highestResVersion && item.status !== releaseStatuses.ReadyForLive"
                          color="accent"
                          (click)="openLinkInNewWindow($event, '/situ-view', { id: item.highestResVersion });" 
                          matTooltip="situVIEW Raytraced+">
                    <mat-icon>8k</mat-icon>
                  </button>
                  <button mat-icon-button 
                          [disabled]="!item?.highestResVersion && !released"
                          color="accent"
                          (click)="openSituLinkInNewWindow($event, item.highestResVersion, false);"
                          matTooltip="situVIEW Raytraced+">
                    <mat-icon>share</mat-icon>
                  </button>
                </ng-container>
                
                <button mat-icon-button *ngIf="!released"
                    [disabled]="!item?.higherResVersion && item.status !== releaseStatuses.ReadyForLive"
                    [color]="item?.approvedByName ? 'accent' : 'primary'"
                    (click)="approveForLive(item); $event.stopPropagation();"
                    [matTooltip]="item?.approvedByName ? 'Approved by ' + (item?.approvedByName ? item?.approvedByName : 'N/A') : 'Approve For Live'">
                  <mat-icon *ngIf="item?.approvedByName">how_to_reg</mat-icon>
                  <mat-icon *ngIf="!item?.approvedByName">done</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="item?.productName == productNames.Facade && !released">
                <div *ngIf="!top100 && !released">|</div>
                <button mat-icon-button 
                        [disabled]="!item?.higherResVersion && !released"
                        color="accent"
                        (click)="openLinkInNewWindow($event, '/situ-facade', { id: item.higherResVersion });"
                        matTooltip="situFACADE">
                  <mat-icon>4k</mat-icon>
                </button>
                <button mat-icon-button 
                        [disabled]="!item?.higherResVersion && !released"
                        color="accent"
                        (click)="openSituLinkInNewWindow($event, item.higherResVersion, true);"
                        matTooltip="situFACADE">
                  <mat-icon>share</mat-icon>
                </button>
              </ng-container>
              <div *ngIf="!top100 && !released">|</div>
              <!-- <ng-container *ngIf="!isSituUser">
                <button *ngIf="!released" mat-icon-button [disabled]="!item?.comments?.trim()"
                  color="accent"
                  (click)="$event.stopPropagation();"
                  [matTooltip]="item?.comments?.trim() ? item.comments : ''">
                  <mat-icon>comment</mat-icon>
                </button>
                <button *ngIf="!released" mat-icon-button [disabled]="!item?.supportTask?.trim()"
                  color="accent"
                  (click)="$event.stopPropagation();"
                  [matTooltip]="item?.supportTask?.trim() ? item.supportTask  : ''">
                  <mat-icon>support</mat-icon>
                </button>
              </ng-container> -->
              <ng-container>
                <button *ngIf="!released" mat-icon-button [disabled]="!item?.releaseIssueReleaseItems?.length > 0"
                  color="primary"
                  (click)="$event.stopPropagation();"
                  matTooltip="{{ item?.releaseIssueReleaseItems?.length + ' issues' }}">
                  <mat-icon>bug_report</mat-icon>
                </button>
              </ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      </ng-container>
      <div #showMoreProductsMarker fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
        <mat-card *ngIf="hasMoreProductsToShow()" class="contrast card-link banner-info w-100" [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="showMoreProducts()">
          <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
            <div fxFlex="100" fxLayoutAlign="center center" fxLayout="row">
              <strong class="text-center" [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_more</mat-icon></strong>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <mat-card fxFlex *ngIf="released && !top100">
        <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
          [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
          (page)="onPageChange($event)">
        </mat-paginator>
      </mat-card>
    </mat-card-content>
  </mat-card>
  <!-- Release Items -->
</div>
